import { EVENT_CATEGORIES, HIT_TYPE, EVENT_NAMES } from 'app-webtech-core/beacon/const';

/**
 * Fires when the UI has loaded (video may or may not be loaded but Channel Guide and other
 * UI elements must be loaded).
 * This does not necessarily mean that the video has started playing, just that
 the app UI has loaded
 */
export const uiLoadedBeacon = () => ({
  hitType: HIT_TYPE.EVENT,
  eventCategory: EVENT_CATEGORIES.LAUNCH,
  eventName: EVENT_NAMES.UI_LOADED,
});
